const comments = [
  {
    id: 1,
    name: '追漫小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20person%20with%20warm%20smile%2C%20simple%20flat%20color%20background%2C%20chibi%20style%2C%20clean%20and%20friendly%2C%20no%20text&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '用了YY漫画之后追漫方便太多了！更新提醒特别及时，下拉式阅读体验丝滑，再也不用到处找资源了。',
    comic: '追《我独自升级》中',
    time: '2小时前',
  },
  {
    id: 2,
    name: '樱花漫语',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20portrait%20of%20a%20girl%20with%20pink%20hair%2C%20simple%20pastel%20background%2C%20chibi%20style%2C%20clean%20and%20friendly%2C%20no%20text&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '韩漫日漫资源真的太全了！之前找了好久的冷门漫画这里都有，翻译质量也很高，推荐给了好多朋友。',
    comic: '沉迷《某天成为公主》',
    time: '5小时前',
  },
  {
    id: 3,
    name: '夜行忍者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20portrait%20of%20a%20cool%20person%20with%20dark%20hair%2C%20simple%20dark%20background%2C%20chibi%20style%2C%20clean%20and%20friendly%2C%20no%20text&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '收藏功能太好用了，几百部追的漫画整理得清清楚楚。智能推荐也超准，推的漫画基本都是我爱的类型。',
    comic: '在追 47 部漫画',
    time: '昨天',
  },
  {
    id: 4,
    name: '小绿家的猫',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20portrait%20of%20a%20person%20with%20green%20hair%20and%20glasses%2C%20simple%20light%20background%2C%20chibi%20style%2C%20clean%20and%20friendly%2C%20no%20text&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '下拉式阅读真的爽！不用翻页一直往下划就行，晚上躲在被窝里刷漫画简直不要太幸福。',
    comic: '喜欢《间谍过家家》',
    time: '昨天',
  },
  {
    id: 5,
    name: '剑客无名',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20portrait%20of%20a%20person%20with%20short%20silver%20hair%2C%20simple%20neutral%20background%2C%20chibi%20style%2C%20clean%20and%20friendly%2C%20no%20text&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '从别的平台转过来的，这里漫画大全真的很全，韩漫更新速度也快。全免费这一点就很良心了。',
    comic: '追《剑尊归来》中',
    time: '2天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者热评</h2>
          <p className="mt-2 text-sm text-foreground-500">来自百万漫迷的真实声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-xl p-5 border border-background-200/60">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
                  <div className="mt-3 flex items-center gap-1.5 text-xs text-primary-500">
                    <i className="ri-bookmark-line"></i>
                    <span className="whitespace-nowrap">{comment.comic}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}